import { asModal } from 'src/components/hoc/asModal'
import { CompanyPersonasEdit } from './edit'
import { CompanyPersonasNew } from './new'

export const PersonaSelectModal = asModal<{
  personaId: number
  close: () => void
}>(
  ({ personaId, close }) => {
    return (
      <>
        {personaId === 0 ? (
          <CompanyPersonasNew close={close} />
        ) : (
          <CompanyPersonasEdit personaId={personaId} close={close} />
        )}
      </>
    )
  },
  { scrollable: true },
)
